<template>
    <div class="text-primary">
        <div class="text-primary p-2">
            <template v-if="selectionDone">
                <div class="text-center confirmed-box-wrapper" @click.prevent="toggleSelection">
                    <template v-if="isMobile">
                        <div class="row">
                            <div class="col-10 text-left">
                                <div class="row">
                                    <div class="col-12">
                                        <h5
                                            class="m-0"
                                            v-html="$t('shop.' + system)"
                                        ></h5>
                                        <span v-html="getVehicleLabel(this.selectedVehicle)"></span>
                                        -
                                        <template v-if="selectedDuration.isAnnual && selectedDuration.yearOfProduct">
                                            {{ getDurationLang(selectedDuration) }}
                                            {{ selectedDuration.yearOfProduct }}
                                        </template>
                                        <template v-else>
                                            {{ selectedDuration.value }}
                                            {{ getDurationLang(selectedDuration) }}
                                        </template>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12">
                                        <h5
                                            class="m-0"
                                            v-html="$t('shopEuropamaut.validTitle')"
                                        ></h5>
                                        {{ getFormattedDate(selectedDateRuntime['from']) }}
                                        -
                                        {{ getFormattedDate(selectedDateRuntime['until']) }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 m-auto">
                                <div class="mobile-edit-icon">
                                    <i class="mdi mdi-square-edit-outline"></i>
                                </div>
                            </div>
                        </div>
                    </template>
                    <ul
                        class="confirmed-box"
                        v-else
                    >
                        <li>
                            <strong
                                class="system-lang-boxed"
                                v-html="$t('shop.' + system)"
                            ></strong>
                        </li>
                        <li
                            class="bubble bubble-selected bubble-selection-done"
                            v-html="getVehicleLabel(this.selectedVehicle)"
                        ></li>
                        <li class="bubble bubble-selected bubble-selection-done duration-text">
                            <template v-if="selectedDuration.isAnnual && selectedDuration.yearOfProduct">
                                {{ getDurationLang(selectedDuration) }}
                                <small>{{ selectedDuration.yearOfProduct }}</small>
                            </template>
                            <template v-else>
                                <span>{{ selectedDuration.value }}</span>
                                <small>{{ getDurationLang(selectedDuration) }}</small>
                            </template>
                        </li>
                        <li class="validity-info">
                            <span>
                                {{ $t('shopEuropamaut.validTitle') }}
                            </span>
                            <small>
                                {{ getFormattedDate(selectedDateRuntime['from']) }}
                                -
                                {{ getFormattedDate(selectedDateRuntime['until']) }}
                                23:59
                            </small>
                        </li>
                        <li>
                            <span class="desktop-edit-entry">
                                <i class="check-icon mdi mdi-check-circle-outline mr-3"></i>
                                {{ $t('shopEuropamaut.changeSelection') }}
                            </span>
                        </li>
                    </ul>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div
                        :class="{
                            'col-10 text-left mb-2': isMobile,
                            'col-12 text-center': !isMobile,
                        }"
                    >
                        <h4 class="system-title">
                            <img
                                class="system-flag mx-2"
                                :alt="systemConfig.systemKey"
                                :src="systemConfig.flag"
                                loading="lazy"
                            >
                            {{ $t('shop.' + system) }}
                        </h4>
                    </div>
                    <template v-if="isMobile">
                        <div class="col-2 text-right">
                            <a
                                class="icon"
                                @click="closeComponent"
                            >
                                <i class="mdi mdi-trash-can-outline"></i>
                            </a>
                        </div>
                    </template>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <h5 class="step-one">
                            {{ $t('shopEuropamaut.stepOne') }}
                            <a class="ml-2" @click.prevent="openVehicleInformationModal">
                                <i class="mdi mdi-information-outline icon"></i>
                            </a>
                        </h5>
                    </div>
                </div>
                <div class="row mt-2">
                    <div
                        class="col-12 bubble-wrapper"
                        :class="{'bubble-scrollable': isMobile}"
                    >
                        <div
                            v-for="vehicleOption in vehicles"
                            :key="vehicleOption.id"
                        >
                            <div
                                v-html="getVehicleLabel(vehicleOption)"
                                class="bubble vehicle-bubble"
                                :class="selectedVehicle.id === vehicleOption.id ? 'bubble-selected' : 'bubble-unselected'"
                                @click.prevent="selectVehicle(vehicleOption)"
                            ></div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="hasVehicleError"
                    class="row mt-2"
                >
                    <span class="col-12 text-danger">
                        {{ $t('shopEuropamaut.uniqueVehicleError') }}
                    </span>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <h5>{{ $t('shopEuropamaut.stepTwo') }}</h5>
                    </div>
                </div>
                <div class="row mt-2">
                    <div
                        class="col-12 bubble-wrapper"
                        :class="{'bubble-scrollable': isMobile}"
                    >
                        <div
                            v-for="duration in durations[selectedVehicle.id]"
                            :key="duration.value + '_' + (Math.random() + 1).toString(36).substring(2)"
                        >
                            <div
                                class="bubble duration-bubble"
                                :class="{
                                    'bubble-selected': durationIsSelected(duration),
                                    'bubble-unselected': durationIsSelected(duration),
                                    'annual-vignette-bubble-width': duration.isAnnual && duration.yearOfProduct
                                }"
                                @click.prevent="selectDuration(duration)"
                            >
                                <template v-if="duration.isAnnual && duration.yearOfProduct">
                                    {{ getDurationLang(duration) }}
                                    <small>{{ duration.yearOfProduct }}</small>
                                </template>
                                <template v-else>
                                    {{ duration.value }}
                                    <small>{{ getDurationLang(duration) }}</small>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <h5>{{ $t('shopEuropamaut.stepThree') }}</h5>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        {{ $t('shopEuropamaut.validTitle') }}
                    </div>
                    <div class="col-12 datepicker-overlay">
                        <DatePicker
                            name="validity_selection"
                            v-model="selectedDate"
                            :config="datepickerPreset"
                            class="datepicker"
                            :class="{ 'validity-disabled': !validityIsControllable }"
                            @dp-change="getRuntimesForSelectedDate();"
                            ref="validitySelection"
                            :mobileIcon="true"
                            :disabled="!validityIsControllable"
                        ></DatePicker>
                    </div>
                    <div
                        class="col-12 mt-1"
                        v-if="!validityIsControllable"
                    >
                        <small>
                            {{ $t('shopEuropamaut.validityUncontrollableMessage') }}
                        </small>
                    </div>
                    <div
                        v-if="hasDurationError"
                        class="col-12 mt-2"
                    >
                        <span class="text-danger">
                            {{ $t('shopEuropamaut.dateOverlap') }}
                        </span>
                    </div>
                </div>
                <div
                    v-if="selectedDateRuntime"
                    class="row mt-2 text-center"
                >
                    <div class="col-12 validity-info">
                        <span>
                            {{ $t('shopEuropamaut.validTitle') }}
                        </span>
                        <span>
                            {{ getFormattedDate(selectedDateRuntime['from']) }}
                            -
                            {{ getFormattedDate(selectedDateRuntime['until']) }}
                            23:59
                        </span>
                    </div>
                </div>
                <div class="row mt-3 text-center">
                    <div :class="{'col-12': isMobile, 'col-6': !isMobile}">
                        <a
                            @click.prevent="toggleSelection()"
                            class="btn btn-primary"
                        >
                            {{ $t('shopEuropamaut.toBasket') }}
                        </a>
                    </div>
                    <div
                        v-if="!isMobile"
                        class="col-6"
                    >
                        <a
                            @click.prevent="closeComponent()"
                            class="remove-product-btn"
                        >
                            {{ $t('shopEuropamaut.deleteButton') }}
                        </a>
                    </div>
                </div>
            </template>
        </div>

        <VehicleInformationModal
            v-if="vehicleInformation.length > 0"
            ref="vehicleInformationModal"
            :vehicle-information="vehicleInformation"
        />
    </div>
</template>

<style lang="scss" scoped>
    ul {
        padding: 0;
    }

    .system-lang-boxed {
        display: inline-block;
        max-width: min-content;
    }

    .confirmed-box-wrapper {
        cursor: pointer;
    }

    .confirmed-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        margin: 0 25px 0 25px;
    }

    .confirmed-box li {
        display: flex;
        margin: 0 7px 0 7px;
        padding: 15px;
    }

    .confirmed-box .bubble {
        min-width: 80px;
    }

    .confirmed-box .check-icon {
        font-size: 35px;
    }

    .confirmed-box .validity-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        max-width: 250px;
    }

    .confirmed-box .validity-info span {
        font-size: 16px;
        font-weight: bold;
    }

    .confirmed-box .validity-info small {
        font-size: 14px;
    }

    .confirmed-box li:first-child {
        width: 120px;
        margin: 0;
    }

    .confirmed-box li:last-child {
        max-width: 200px;
        min-width: 170px;
        margin: 0;
    }

    .confirmed-box li:last-child {
        justify-content: right;
    }

    .duration-text span {
        font-size: 20px;
        margin-bottom: -5px;
    }

    .duration-text small {
        font-size: 14px;
    }

    .step-one {
        display: flex;
        align-items: center;
    }

    .bubble-scrollable {
        overflow: scroll;
        padding-bottom: 10px;
        scrollbar-color: var(--main-color);
    }

    .bubble-wrapper {
        display: flex;
        align-items: center;
        justify-content: left;
        height: 100%;
        margin: 0;
    }

    .bubble-wrapper .bubble {
        padding: 15px;
        margin-right: 15px;
    }

    .bubble {
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        height: 55px;
        text-align: center;
        border: var(--main-color) 2px solid;
    }

    .bubble-unselected {
        color: var(--main-color);
    }

    .bubble:hover,
    .bubble-selected {
        background-color: var(--main-color);
        color: #FFFFFF;
    }

    .bubble-selection-done {
        width: 150px;
    }

    .vehicle-bubble {
        height: 70px;
        min-width: 100px;
    }

    .duration-bubble {
        width: 80px;
    }

    .annual-vignette-bubble-width {
        width: auto;
        max-width: 165px;
    }

    .datepicker {
        border: 1.5px solid var(--main-color);
    }

    .validity-info {
        font-weight: bold;
    }

    .validity-info span {
        font-size: 20px;
    }

    .validity-disabled {
        filter: opacity(0.5);
    }

    .desktop-edit-entry {
        display: flex;
        align-items: center;
    }

    .remove-product-btn {
        cursor: pointer;
        text-decoration: underline !important;
    }

    .icon {
        font-size: 24px;
        cursor: pointer;
    }

    .system-flag {
        width: 35px;
        height: auto;
    }

    .system-title {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media only screen and (max-width: 1024px) {
        h5 {
            text-align: left;
        }

        .system-title {
            justify-content: left;
        }

        .validity-info span {
            font-size: 14px;
            display: flex;
            flex-direction: column;
        }

        .mobile-edit-icon {
            font-size: 30px;
        }
    }
</style>

<script>
import isEqual from 'lodash/isEqual';
import VehicleInformationModal from '../Shop/VehicleInformationModal.vue';
import DatePicker from '../DatePicker.vue';

export default {
    name: 'ProductSelection',

    components: {
        VehicleInformationModal,
        DatePicker,
    },

    props: [
        'isMobile',
        'system',
        'vehicles',
        'durations',
        'products',
        'datepickerConfig',
        'hasDurationError',
        'hasVehicleError',
        'systemConfig',
        'preselectedVehicle',
        'preselectedProduct',
        'preselectedDate',
    ],

    data() {
        return {
            selectedProduct: [],
            selectedVehicle: [],
            selectedDuration: [],
            selectedDate: this.datepickerConfig['default'],
            selectedDateRuntime: [],
            selectionDone: false,
            datepickerPreset: this.$datePickerOptions,
            validityIsControllable: false,
            forceClose: false,
        };
    },

    computed: {
        vehicleInformation() {
            const vehicleInformation = [];

            if (
                !this.selectedProduct
                || !this.selectedProduct.options
            ) {
                return vehicleInformation;
            }

            this.selectedProduct.options.forEach((opt) => {
                if (opt.vehicleDescriptions) {
                    const description = opt.vehicleDescriptions[this.$language] ?? opt.vehicleDescriptions['en'];

                    if (description) {
                        vehicleInformation.push(description.trim());
                    }
                }
            });

            return vehicleInformation;
        },

        selectedOption() {
            if (this.selectedProduct && this.selectedVehicle && this.selectedProduct.options) {
                return this.selectedProduct.options.find((x) => {
                    return x.type === this.selectedVehicle.type && isEqual(x.fuel, this.selectedVehicle.fuel);
                });
            }

            return null;
        },

        selectedProductIsPreorder() {
            return this.selectedProduct?.preorderFrom !== null &&
                new Date(this.selectedProduct.preorderFrom) >= new Date();
        },
    },

    methods: {
        sortVehicles() {
            this.vehicles.sort((vehicle1, vehicle2) => {
                if (vehicle1.sort !== null && vehicle2.sort !== null) {
                    return vehicle1.sort - vehicle2.sort;
                }

                return this.sortByField(vehicle1, vehicle2, 'vehicle_type');
            });
        },

        sortByField(vehicle1, vehicle2, field) {
            if (vehicle1[field] === vehicle2[field]) {
                return 0;
            }

            return vehicle1[field] < vehicle2[field] ? 1 : -1;
        },

        preselectData() {
            let preselectedVehicle, preselectedDuration = null;

            if (this.preselectedVehicle) {
                preselectedVehicle = this.getPreselectedVehicle();
            }

            this.selectedVehicle = preselectedVehicle ?? this.vehicles[0] ?? [];

            if (this.preselectedProduct) {
                const preselectedProduct = this.products.find((v) => v.id === this.preselectedProduct);
                if (preselectedProduct) {
                    preselectedDuration = this.durations[this.selectedVehicle.id].find((obj) => {
                        return obj.value === preselectedProduct.duration.value &&
                            obj.isMonth === preselectedProduct.duration.isMonth;
                    });
                }

                this.forceClose = true;
            }

            this.selectedDuration = preselectedDuration ?? this.durations[this.selectedVehicle.id][0] ?? [];
        },

        getPreselectedVehicle() {
            const options = this.products.flatMap(product => product.options);
            const option = options.find(option => option.id === this.preselectedVehicle);
            return this.vehicles.find((v) => v.type === option.type && v.fuel.type === option.fuel.type);
        },

        getVehicleLabel(vehicleOption) {
            if (vehicleOption.length <= 0) {
                return;
            }

            if (
                vehicleOption.vehicleNames === null ||
                !vehicleOption.vehicleNames ||
                vehicleOption.vehicleNames.length <= 0
            ) {
                return vehicleOption.labels[this.$language] ?? vehicleOption.label['en'];
            }

            return vehicleOption.vehicleNames[this.$language] ?? vehicleOption.vehicleNames['en'];
        },

        durationIsSelected(duration) {
            return this.selectedDuration.value === duration.value &&
                this.selectedDuration.isMonth === duration.isMonth;
        },

        selectVehicle(vehicleOption) {
            this.selectedVehicle = vehicleOption;
        },

        selectDuration(durationObj) {
            this.selectedDuration = durationObj;
        },

        setSelectedProduct() {
            this.selectedProduct = this.products.find(product => {
                return product.duration.value === this.selectedDuration.value &&
                    product.duration.isMonth === this.selectedDuration.isMonth &&
                    product.options.find(option => {
                        return option.type === this.selectedVehicle.type && !option.fuel.type ||
                            (
                                option.fuel &&
                                option.fuel.type === this.selectedVehicle.fuel.type &&
                                option.type === this.selectedVehicle.type
                            );
                    });
            });

            // If the selected product is a preorder,
            // we need to overwrite the selected date and
            // use the earliest runtime.
            if (this.selectedProductIsPreorder) {
                this.selectedDate = this.getEarliestRuntime(this.selectedProduct);
            }
        },

        getEarliestRuntime(selectedProduct) {
            return this.getFormattedDate(
                selectedProduct.runtimes.find(runtimeObj => {
                    return new Date(runtimeObj.from) >= new Date();
                })?.from
            );
        },

        presetDatepicker() {
            this.datepickerPreset['minDate'] = this.getDatepickerMinDate();
            this.datepickerPreset['maxDate'] = this.getDatepickerMaxDate();

            if (
                this.preselectedDate &&
                new Date(this.preselectedDate) >= new Date(this.datepickerPreset['minDate']) &&
                new Date(this.preselectedDate) <= new Date(this.datepickerPreset['maxDate'])
            ) {
                this.selectedDate = this.preselectedDate.split('-').reverse().join('.');
            }
        },

        overrideMountedDatepickerDates() {
            const minDate = this.getDatepickerMinDate(), maxDate = this.getDatepickerMaxDate();

            this.$refs.validitySelection.setMinDate(minDate);
            this.$refs.validitySelection.setMaxDate(maxDate);

            if (new Date(this.selectedDate.split('.').reverse().join('-')) > new Date(maxDate)) {
                this.selectedDate = this.datepickerConfig.default;
            }
        },

        getDatepickerMinDate() {
            let validFrom = null;
            const minDate = this.datepickerConfig['minDate'];

            if (
                this.selectedOption &&
                this.selectedOption.validFrom
            ) {
                validFrom = new Date(this.selectedOption.validFrom);
            }

            if (validFrom && validFrom >= minDate) {
                return validFrom;
            }

            return minDate;
        },

        getDatepickerMaxDate() {
            const maxDate = this.datepickerConfig['maxDate'];
            if (
                this.selectedOption &&
                this.selectedOption.validUntil
            ) {
                return new Date(this.selectedOption.validUntil);
            }

            let lastMaxDate = this.selectedProduct.runtimes[this.selectedProduct.runtimes.length - 1];
            if (lastMaxDate && lastMaxDate['until']) {
                lastMaxDate = new Date(lastMaxDate['until']);
            }

            return lastMaxDate ?? maxDate;
        },

        getRuntimesForSelectedDate() {
            this.setSelectedProduct();
            this.overrideMountedDatepickerDates();

            const productRuntimes = this.selectedProduct?.runtimes;
            this.selectedDateRuntime = productRuntimes.find(rt => {
                const parts = this.selectedDate.split('.');
                return rt.from === `${parts[2]}-${parts[1]}-${parts[0]}`;
            });
        },

        getFormattedDate(date, separator = '-') {
            if (!date) {
                return;
            }

            // Return a readable date to display.
            const parts = date.split(separator);
            return `${parts[2]}.${parts[1]}.${parts[0]}`;
        },

        getDurationLang(duration) {
            let lang = 'shopEuropamaut.';
            const isMonth = duration.isMonth;
            const value = duration.value;

            if (
                duration.isAnnual &&
                duration.yearOfProduct
            ) {
                lang += 'kombivignetteDurationAnnual';
            } else if (isMonth && value === 1) {
                lang += 'kombivignetteDurationMonth';
            } else if (isMonth && value > 1) {
                lang += 'kombivignetteDurationMonths';
            } else if (value === 1) {
                lang += 'kombivignetteDurationDay';
            } else {
                lang += 'kombivignetteDurationDays';
            }

            return this.$t(lang);
        },

        openVehicleInformationModal() {
            this.$refs.vehicleInformationModal.showModal();
        },

        toggleSelection() {
            this.selectionDone = !this.selectionDone;

            if (!this.selectionDone) {
                const date = this.selectedDate;
                setTimeout(() => {
                    this.selectedDate = date;
                    const dateParts = date.split('.');
                    this.$refs.validitySelection.setDate(new Date(`${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`));
                }, 5);
            }
        },

        closeComponent() {
            this.$emit('close-component');
        },
    },

    watch: {
        selectedDate() {
            this.$emit('product-updated');
        },

        selectedProduct() {
            this.validityIsControllable = this.selectedProduct.validityIsControllable;
            this.$emit('product-updated');
        },

        selectionDone() {
            this.$emit('product-updated');
        },

        selectedVehicle() {
            // Try to preselect the last duration.
            const previousDuration = this.selectedDuration;
            const durationObj = this.durations[this.selectedVehicle.id] ?? [];
            let duration = durationObj[0];
            if (
                durationObj.length > 0 &&
                !isEqual(previousDuration, duration)
            ) {
                const possibleDuration = durationObj.find((x) => {
                    return isEqual(x, previousDuration);
                });

                if (possibleDuration) {
                    duration = possibleDuration;
                }
            }

            this.selectedDuration = duration;
            this.setSelectedProduct();
            this.$emit('product-updated');
        },

        selectedDuration() {
            this.getRuntimesForSelectedDate();
        },

        hasVehicleError() {
            if (this.hasVehicleError) {
                this.selectionDone = false;
            }
        },

        hasDurationError() {
            if (this.hasDurationError) {
                this.selectionDone = false;
            }
        },
    },

    mounted() {
        this.sortVehicles();
        this.preselectData();
        this.setSelectedProduct();
        this.presetDatepicker();

        if (this.forceClose) {
            this.toggleSelection();
        }
    },
};
</script>
